// import { Carousel } from '@material-tailwind/react'y
import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "../../styles/Events.css";
import img1 from "../../global-images/bg-6.png";
import img2 from "../../global-images/bg-2.jpg";
import img3 from "../../global-images/bg-3.jpg";
import img4 from "../../global-images/bg-6.png";
import img5 from "../../global-images/spiderman-into-the-spider-verse.jpg";
import logo1 from "../../global-images/logo3.jpg";
import img6 from "../ProgramImages/2.png";
import img7 from "../ProgramImages/1.png";
import img8 from "../ProgramImages/3.png";
import img9 from "../ProgramImages/4.png";
import img10 from "../ProgramImages/5.png";
import img11 from "../ProgramImages/6.png";
import img12 from "../ProgramImages/7.png";
import img13 from "../ProgramImages/12.jpg";
import img14 from "../ProgramImages/13.jpg";
import img15 from "../ProgramImages/14.jpg";
import img16 from "../ProgramImages/15.jpg";
import img17 from "../ProgramImages/16.jpg";
import img18 from "../ProgramImages/17.jpg";
import img19 from "../ProgramImages/18.jpg";

import himtech from "./Himtech.jpg";
import { MdLocationOn } from "react-icons/md";
import { Calendar } from "lucide-react";
import Bioindia from "./BioIndia.png";
// import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel"
function Events() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [transition, setTransition] = useState(true);
  const images = [
    {
      src: himtech,
      title: "HIMTECH 2024",
      description:
        "Exposition to showcase High Altitude Areas(HAA) Solution in Domains",
      Venue: "Rinche Auditorium Grounds, Leh",
      Time: "10:00 AM",
      Date: "20-21 Spetember 2024",
    },
    {
      src: Bioindia,
      title: "Global Bio-India 2024",
      description:
        "Global Bio-India 2024 is a mega international congregation of biotechnology stakeholders, including international bodies, regulatory bodies, central and state ministries, SMEs, large industries, bioclusters, research institutes, investors, and the startup ecosystem",
      Venue: "Pragati Maidan",
      Time: "10:00 AM",
      Date: "12-14 September, 2024",
    },
  ];
  const pastEvents = [
    {
      img: img11,
      description:
        "Presenting IIT Ropar TBIF at BIOASIA 2024 Summit ,Hyedrabad ",
    },
    {
      img: img10,
      description:
        "Advance Combat Uniform with Near Infra-Red(NIR) Concealement technology for Indian Army",
    },
    {
      img: img9,
      description: "Indian Army taking a taste of UAV Technologies",
    },
    {
      img: img8,
      description:
        "General Anil Chauhan, Chief of Defence Staff, Indian Armed Forces at TBIF’s stall during the Northtech symposium.",
    },
    {
      img: img7,
      description: "Drone Workshop for Indian Army",
    },
    {
      img: img12,
      description:
        "Interaction with CM Punjab Shri. Bhagwant Mann ji at the Progressive Punjab Investment Summit 2023",
    },
    {
      img: img13,
      description:"",
    },
    {
      img: img14,
      description:"",
    },
    {
      img: img15,
      description:"",
    },
    {
      img: img16,
      description:"",
    },
    {
      img: img17,
      description:"",
    },
    {
      img: img18,
      description:"",
    },
    {
      img: img19,
      description:"",
    },

  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setTransition(false);
      setTimeout(() => {
        setActiveIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
        setTransition(true);
      }, 300); // Transition duration
    }, 3500); // Slide change interval

    return () => clearInterval(interval);
  }, []);

  // const handlePrev = () => {
  //   setTransition(false);
  //   setTimeout(() => {
  //     setActiveIndex((prevIndex) =>
  //       prevIndex === 0 ? images.length - 1 : prevIndex - 1
  //     );
  //     setTransition(true);
  //   }, 300); // Transition duration
  // };

  const handleNext = () => {
    setTransition(false);
    setTimeout(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
      setTransition(true);
    }, 300); // Transition duration
  };

  return (
    <div className="bg-white">
      <div className=" pt-28 bg-transparent ">
        <div className="">
          <div className=" sm:text-4xl px-8 lg:text-5xl p-4 text-center  bg-clip-text text-transparent flex justify-center font-montserrat lg:mb-5 text-black text-3xl">
            <div className="text-blue-600">U</div><div>pcoming Events</div>
          </div>
        </div>
        <div className="relative flex mx-10 items-center justify-center h-screen overflow-hidden rounded-3xl">
          <div className="relative w-full h-full">
            {images.map((image, index) => (
              <div
                key={index}
                className={`absolute top-0 left-0 w-full h-full transition-transform duration-500 ease-in-out ${
                  index === activeIndex
                    ? "translate-x-0"
                    : index > activeIndex
                    ? "translate-x-full"
                    : "-translate-x-full"
                }`}
              >
                <img
                  src={image.src}
                  alt={`image ${index + 1}`}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 grid h-full w-full place-items-center py-24 bg-black/70 text-white">
                  <div className="w-3/4 text-center md:w-2/4 place-content-center">
                    <p
                      variant="h1"
                      color="white"
                      className="mb-4 text-3xl md:text-4xl lg:text-5xl"
                    >
                      {image.title}
                    </p>
                    <div className="flex grid-flow-col place-content-center p-4">
                      <Calendar className="text-white size-5 place-content-center mt-1 mr-3"></Calendar>
                      <h1 className="text-white text-center font-montserrat text-xl">
                        {image.Time} , {image.Date}
                      </h1>
                    </div>
                    {/* <h1 className="text-white text-center font-montserrat text-2xl"></h1> */}
                    <div className="flex grid-flow-col place-content-center p-4">
                      <MdLocationOn className="text-white sm:size-5 md:size-7 lg:size-10  mt-1 mr-3"></MdLocationOn>
                      <h1 className="text-white text-center font-montserrat sm:text-xl md:text-2xl lg:text-4xl">
                        {image.Venue}
                      </h1>
                    </div>

                    <p variant="lead" color="white" className="">
                      {image.description}
                    </p>
                  </div>
                </div>
                <div className="text-white text-center mt-4">
                  Image {index + 1} of {images.length}
                </div>
              </div>
            ))}
          </div>

          {/* <button
            className="absolute top-1/2 left-0 hover:animate-pulse transform -translate-y-1/2 text-blue-600 bg-black p-2 rounded-[0px_10px_10px_0px] shadow-lg hover:shadow-[0_0_40px] z-10"
            onClick={handlePrev}
          >
            <FaArrowLeft className="w-6 h-32 " />
          </button>
          <button
            className="absolute top-1/2 right-0 hover:animate-pulse transform -translate-y-1/2 text-blue-600 bg-white p-2 rounded-[10px_0px_0px_10px] shadow-lg hover:shadow-[0_0_40px_blue]  z-10"
            onClick={handleNext}
          >
            <FaArrowRight className="w-6 h-32 " />
          </button> */}
        </div>
        <div className="border-b border-gray-700 pb-10">
          <div className="text-black xs:text-4xl sm:text-4xl lg:text-5xl flex justify-center text-center p-10 text-3xl font-montserrat">
            <div className="text-blue-600">P</div><div>ast Events</div>
          </div>
          <div className="grid gap-6 mx-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            {pastEvents.map((event, index) => (
              <div
                key={index}
                className="relative cursor-pointer bg-gray-800 rounded-2xl overflow-hidden shadow-lg group">
                <img
                  src={event.img}
                  alt={event.title || `Event ${index + 1}`}
                  className="w-full lg:h-64 h-80 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {event.title && (
                    <h3 className="text-lg font-semibold text-white mb-2">{event.title}</h3>
                  )}
                  <p className="text-sm text-gray-200">{event.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Events;
